import React from 'react';
import styled from 'styled-components';
import {Link} from 'gatsby';
import Image from 'gatsby-image';

const CardWrapper = styled.div`
    /* min-height:560px; */
    /* height: 100%; */
    max-width: 400px;
    background-color: red;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;
    position: relative;
    flex-basis: ${({items}) => items === 3 ? "33%" : "23%" };
    margin-bottom: 3rem;
    box-shadow: 1px 2px 10px rgba(129, 53, 53, 0.2);

    h3 {
        font-family: "EB Garamond";
        font-weight: 300;
        font-size: 1.9rem;
        text-align: center;
    }
    p {
        text-align: center;
        padding: 1rem;
    }
    
    @media (max-width: 1400px) {
        flex-basis: 33%;
        max-width: 330px;
    }

    @media (max-width: 1080px) {
        flex-basis: 44%;
        max-width: 320px;
    }
    @media (max-width: 750px) {
        flex-basis: 80%;
        max-width: 320px;
    }
`;

const CardImage = styled(Image)`
    object-fit: cover;
    width: 127%;
    height: 15vw;
    margin-top: 1rem;
    transition: 0.3s ease-in-out;
    cursor: ${({link}) => link ? "pointer" : "auto"};
    picture {
        img {
            transition: scale 0.3s ease-in-out;
        }
    }
    @media (max-width: 1400px) {
        height: 20vw;
    }

    @media (max-width: 1080px) {
        height: 28vw;
    }
    @media (max-width: 750px) {
        height: 33vw;
    }
`;

const ImageLink = styled(Link)`
    display: block;
    cursor: pointer;
    ${({resize}) => resize === "yes" ? `&:hover { div picture img{ transform: scale(1.2); }}` : null}
    div {
        picture {
            img {
                transition: scale ease 0.3s;
            }
        }
    }
`;

const CardBar = styled.div`
    width: 100%;
    height: 1rem;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #FDFF9C;
`;



class Card extends React.Component {
    constructor(props) {
        super(props) 
    }
    componentDidMount() {
        const pictures = document.querySelectorAll('picture>img');
        const addTransition = () => {
            pictures.forEach(picture => picture.style.transition = 'ease 0.3s')
        }
        if (this.props.resize === "yes") {
            addTransition()  
        }
        else {
            return null
        }
                  
    }
    
    render() {
    return (
        <CardWrapper items={this.props.items}>
            <ImageLink className="image" to={this.props.link} resize={this.props.resize} target={this.props.target === "yes" ? "_blank" : null}>
                <CardImage fluid={this.props.image} alt={this.props.alt} link={this.props.link}/>
            </ImageLink>
            <div className="text">
                <h3>{this.props.title}</h3>
                <p>{this.props.text}</p>
            </div>
            <CardBar></CardBar>
        </CardWrapper>
    )
    }
}

export default Card